
export enum WsOutEvent {
  AuthorizeSuccess= 'AuthorizeSuccess',
  Pong= 'Pong',
  UnauthorizeSuccess= 'UnauthorizeSuccess',
  AuctionDetailSnapshot= 'AuctionDetailSnapshot',
  AuctionListingSnapshot= 'AuctionListingSnapshot',
  AuctionWon= 'AuctionWon',
  DirectSaleDetailSnapshot= 'DirectSaleDetailSnapshot',
  DirectSaleNegotiationAbortedDueToAnotherAcceptance= 'DirectSaleNegotiationAbortedDueToAnotherAcceptance',
  DirectSaleNegotiationAcceptedByBuyer= 'DirectSaleNegotiationAcceptedByBuyer',
  DirectSaleNegotiationAcceptedBySeller= 'DirectSaleNegotiationAcceptedBySeller',
  DirectSaleNegotiationExpired= 'DirectSaleNegotiationExpired',
  DirectSaleNegotiationProposalByBuyer= 'DirectSaleNegotiationProposalByBuyer',
  DirectSaleNegotiationProposalBySeller= 'DirectSaleNegotiationProposalBySeller',
  DirectSalePurchased= 'DirectSalePurchased',
  DirectSaleUserMetaSnapshot= 'DirectSaleUserMetaSnapshot',
  DirectSalesListingSnapshot= 'DirectSalesListingSnapshot',
  NegotiationAcceptedByBuyer= 'NegotiationAcceptedByBuyer',
  NegotiationAcceptedBySeller= 'NegotiationAcceptedBySeller',
  NegotiationDeclinedBySeller= 'NegotiationDeclinedBySeller',
  NegotiationExpired= 'NegotiationExpired',
  NegotiationProposalByBuyer= 'NegotiationProposalByBuyer',
  NegotiationProposalBySeller= 'NegotiationProposalBySeller',
  NegotiationStarted= 'NegotiationStarted',
  NegotiationStoppedProposalsByBuyer= 'NegotiationStoppedProposalsByBuyer',
  SetupIntentFailed= 'SetupIntentFailed',
  SetupIntentSucceeded= 'SetupIntentSucceeded',
  UserAutoBidMaxThresholdReached= 'UserAutoBidMaxThresholdReached',
  UserBailAuthorized= 'UserBailAuthorized',
  UserMaxBidderRestored= 'UserMaxBidderRestored',
  UserMetaSnapshot= 'UserMetaSnapshot',
  UserOffersUpdate= 'UserOffersUpdate',
  UserOutBid= 'UserOutBid',
  UserWinningBid= 'UserWinningBid',
  DirectSaleNegotiationAcceptedByBackoffice= 'DirectSaleNegotiationAcceptedByBackoffice',
  NegotiationAcceptedByBackoffice= 'NegotiationAcceptedByBackoffice',
  UserFavoriteAssetsAdded= 'UserFavoriteAssetsAdded',
  UserFavoriteAssetsRemoved= 'UserFavoriteAssetsRemoved',
  UserFavoriteAssetsSnapshot= 'UserFavoriteAssetsSnapshot',

}